import { AuthId } from "@common/constans";
import { IAirCheckinRequest, IResponse, ITripTrackingTrack, ITripTrackingTrip } from "@common/models";
import { IShareInitializeResponse } from "@common/models/ShareInitializeResponse";
import Api, { IOptions } from "@service/Api";
import { Action } from ".";

export function getTripTrackLink<T = IAirCheckinRequest, U = IShareInitializeResponse>(action: Action, options?: IOptions<T>): Promise<IResponse<U>> {
    switch (action) {
        case Action.POST:
            return Api.post<T, U>("TripTracking/ShareInit", {
                ...options,
                raiseError: options?.raiseError ?? true,
                authenticationId: options?.authenticationId ?? AuthId.OnlineCheckin,
                callBackTrigger: options?.callBackTrigger ?? true
            });
    }
    return Promise.reject();
}

export function getTrip<T = IAirCheckinRequest, U = ITripTrackingTrip>(action: Action, options?: IOptions<T>): Promise<IResponse<U>> {
    switch (action) {
        case Action.POST:
            return Api.post<T, U>("TripTracking/Trip", { ...options, raiseError: options?.raiseError ?? true });
    }
    return Promise.reject();
}

export function getTrack<T = IAirCheckinRequest, U = ITripTrackingTrack>(action: Action, options?: IOptions<T>): Promise<IResponse<U>> {
    switch (action) {
        case Action.POST:
            return Api.post<T, U>("TripTracking/Track", { ...options, raiseError: options?.raiseError ?? false });
    }
    return Promise.reject();
}